import React, { memo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Icon } from '@mui/material';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Tooltip } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import './styles.scss';

import {
  onRefreshRoutes,
  drawGetDirections
} from 'Redux/actions'

import {
  routesDeleteRoutes,
  routesDeleteMultipleRoutes,
  openModalDeleteRoutes,
  routesDeleteStop,
  reset,
  minimizeModal,
  restoreModal
} from './redux/slice'

import { routesEditPanelRouteGetRoute } from '../editPanelRoute/redux/slice'

import { reset as resetCreateEditRouteModalMain } from '../createEditRouteModalMain/redux/slice'

const ROUTE_KEY = "route";
const ROUTE_MULTIPE_KEY = "route_multiple";
const STOP_KEY = "stop";

const MODAL_HEADER_WIDTH = 374;

const FSMDeleteRoute = (props) => {
  const dispatch = useDispatch();

  const { intl, isMainView = false } = props;
  const { messages } = intl;

  const openModal = useSelector(state => state.routesManagerDeleteRedux?.openModal);
  const minimized = useSelector(state => state.routesManagerDeleteRedux?.minimized);
  const isRealtime = useSelector(state => state.routesManagerDeleteRedux?.isRealtime);
  const isDeleteRoutes = useSelector(state => state.routesManagerDeleteRedux.isDeleteRoutes);
  const deleteModalData = useSelector(state => state.routesManagerDeleteRedux);
  const loadingDelete = useSelector(state => state.routesManagerDeleteRedux.loading);
  const loadingDeleteRoute = useSelector(state => state.routesManagedRedux.loading);
  const loading = loadingDelete || loadingDeleteRoute;

  
  const erorrRoutes = useSelector(state => state.routesManagedRedux.erorrRoutes);

  //selector for deleteRoutesModal
  const isDeletePoint = useSelector((state) => state.routesManagerDeleteRedux.isDeletePoint);

  useEffect(() => {
    if (openModal && (isDeleteRoutes || isDeletePoint)) {
      if (erorrRoutes) {
        NotificationManager.error(
          messages['routes_error'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
      } else {
        NotificationManager.success(
          deleteModalData?.rows ? messages['routes_deleteRoutesSuccess'] : messages['fsmRoute_modal_delete_delete_stop_sucess'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );
        
      }
      
      //is for edit view
      if (deleteModalData?.type === STOP_KEY){
        dispatch(resetCreateEditRouteModalMain({deleteAllRoutePointsResponse : false, errorOnMap: null}))
        if(deleteModalData?.routeId > 0){
          dispatch(routesEditPanelRouteGetRoute({id: deleteModalData?.routeId}))
        }
      }else{
        if(isRealtime){
          //remove item to the list.
          dispatch(onRefreshRoutes(true))
        }
      }
      dispatch(drawGetDirections(false));
      dispatch(reset());
      
      handleClose();
      //dispatch(reset())
    }
    
  }, [isDeleteRoutes, isDeletePoint]);


  const handleClose = useCallback(() => {
    dispatch(openModalDeleteRoutes({ open: false }))
  });

  return (
    <Modal
      className={isMainView ? undefined : "modal-top-0"}
      handleClose={handleClose}
      headerStyle={isMainView
        ? { width: MODAL_HEADER_WIDTH }
        : { top: 0, width: MODAL_HEADER_WIDTH }
      }
      open={openModal && !minimized}
      position="right"
      size="280px"
      title={deleteModalData?.title || messages['routes_delete_routes_title']}
    >
      <ModalBody>
        <div className="delete-route-body">
          <div className="delete-route-warning">
            <p>{((deleteModalData?.content ?? '').split('\n')[0])}</p>
            <p>{((deleteModalData?.content ?? '').split('\n')[1]) ?? ''}</p>
          </div>

          {deleteModalData?.rows && deleteModalData.rows.length > 0 && (
            <ul className="delete-routes-list">
              {deleteModalData.rows.map((item) => (
                <li key={item?.id} className="delete-route-item">
                  <Icon className="delete-route-icon">alt_route</Icon>
                  <Tooltip title={item.name} placement="bottom">
                    <span className="delete-route-name">{item.name}</span>
                  </Tooltip>
                </li>
              ))}
            </ul>
          )}
        </div>
      </ModalBody>

      <ModalFooter style={{ bottom: 50 }}>
        <Button
          disabled={loading}
          onClick={handleClose}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loading}
          onClick={(e) => {
            if (e) e.preventDefault();
            if (deleteModalData?.type === ROUTE_KEY) {
              dispatch(routesDeleteRoutes({ id: deleteModalData.id }));
            } else if (deleteModalData?.type === ROUTE_MULTIPE_KEY) {
              dispatch(routesDeleteMultipleRoutes({ arrayDeleteRoutes: deleteModalData?.rows.map((item)=> item.id) }));
            } else if (deleteModalData?.type === STOP_KEY) {
              dispatch(routesDeleteStop({ id: deleteModalData.id }));
            }
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default injectIntl(memo(FSMDeleteRoute));